<template>
  <div class="sysStoreEdit w-label">
    <form-header :page-title="`${id?'编辑':'新增'}系统门店清单`" @save="submitForm"></form-header>
    <div class="content-area white-bg-radius">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="系统："
          prop="system"
          :rules="[{required: true, message: '此项为必填项'}]"
          v-if="!id"
          >
          <el-select v-model="form.system"
            value-key="id"
            placeholder="请选择"
            @change="systemChange"
            :clearable="true">
            <el-option
              v-for="item in systems"
              :key="item.id"
              :label="item.code + ' ' + item.name"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- previous Code-1-->
        <!-- <el-form-item label="系统："  v-else>
          <div>{{form.sysName}}</div>
        </el-form-item> -->
         <el-form-item label="系统：" v-else>
          <el-input v-model="form.sysName" :disabled="true" class="input">
          </el-input>
        </el-form-item>
        <el-form-item label="达能门店代号："
          prop="wwStoreCode"
          :rules="[{required: true, message: '此项为必填项'}]"
          v-if="!id"
          >
          <el-input v-model="form.wwStoreCode" placeholder="请输入" class="input">
            <span slot="prepend">{{form.system && form.system.code}}</span>
          </el-input>
        </el-form-item>
        <!-- previous Code-2-->
        <!-- <el-form-item label="达能门店代号：" v-else>
          <div>{{form.wwStoreCode}}</div>
        </el-form-item> -->
         <el-form-item label="达能门店代号：" v-else>
          <el-input v-model="form.wwStoreCode" :disabled="true" class="input">
          </el-input>
        </el-form-item>
        <el-form-item label="达能门店名称："
          prop="wwStoreName"
          :rules="[{required: true, message: '此项为必填项'}]"
          >
          <el-input v-model="form.wwStoreName" placeholder="请输入" class="input">
          </el-input>
        </el-form-item>
        <el-form-item label="系统门店代号："
          prop="sysStoreCode"
          :rules="[{required: true, message: '此项为必填项'}]"
          >
          <el-input v-model="form.sysStoreCode" placeholder="请输入" class="input">
          </el-input>
        </el-form-item>
        <el-form-item label="系统门店名称："
          prop="sysStoreName"
          :rules="[{required: true, message: '此项为必填项'}]"
          >
          <el-input v-model="form.sysStoreName" placeholder="请输入" class="input">
          </el-input>
        </el-form-item>
        <el-form-item label="是否停业："
          prop="status"
          :rules="[{required: true, message: '此项为必填项'}]"
          >
          <el-radio v-model="form.status" label="Y" @change="change">Y</el-radio>
          <el-radio v-model="form.status" label="N" @change="change">N</el-radio>
        </el-form-item>
        <el-form-item label="业绩拆分地分公司："
          prop="splitGround"
          :rules="[{required: true, message: '此项为必填项'}]"
          >
          <el-select v-model="form.splitGround"
            :filterable="true"
            value-key="vkorg"
            placeholder="请输入分公司名称或代号" :clearable="true">
            <el-option
              v-for="item in companies"
              :key="item.vkorg"
              :label="item.vkorg + ' ' + item.vremark"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="大仓所在地分公司："
          prop="warehousePlot"
          :rules="[{required: true, message: '此项为必填项'}]"
          >

          <el-select v-model="form.warehousePlot"
            :filterable="true"
            value-key="vkorg"
            placeholder="请输入分公司名称或代号" :clearable="true">
            <el-option
              v-for="item in companies"
              :key="item.vkorg"
              :label="item.vkorg + ' ' + item.vremark"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开单客户代号："
          prop="sapCustomerCode"
          :rules="[{required: true, message: '此项为必填项'}]"
          class="clickable"
          >
          <!--<el-tooltip :content="form.SAP_OrderCustomer"-->
            <!--:disabled="!form.SAP_OrderCustomer || form.SAP_OrderCustomer.length<24"-->
            <!--placement="top">-->
            <el-input
              v-model="form.sapCustomerCode"
              placeholder="请选择"
              class="input"
              suffix-icon="el-icon-tickets"
              @focus="openSAPDialog"
              :readonly="true"
              >
              <i v-if="form.sapCustomerCode" class="el-icon-error"  slot="append" @click.stop.prevent="clear"></i>
            </el-input>
          <!--</el-tooltip>-->
        </el-form-item>
        <el-form-item label="开单客户名称：">
           <div class="input">{{form.SAP_OrderCustomer}}</div>
        </el-form-item>
        <el-form-item label="送货分公司：">
          <div class="input">{{form.wwDeliveryBranchOfficeCode}} {{form.wwDeliveryBranchOfficeName}}</div>
        </el-form-item>
        <el-form-item label="开单分公司：">
          <div class="input">{{form.wwOpeningBranchOfficeCode}} {{form.wwOpeningBranchOfficeName}}</div>
        </el-form-item>
        <el-form-item label="开单渠道名称：">
          <div class="input">{{(form.wwOpeningOrderChannelCode || '') + (form.productSpart || '')}} {{form.wwOpeningOrderChannelName || ''}}</div>
        </el-form-item>
        <!--<el-form-item label="是否冻结：">-->
          <!--<div class="input">{{form.frozen}}</div>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="是否删除：">-->
          <!--<div class="input">{{form.deleted}}</div>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="订单别：">-->
          <!--<div class="input">{{form.orderType}}<span v-if="form.orderType">{{{'W':'统仓','D':'门店'}[form.orderType]}}</span></div>-->
        <!--</el-form-item>-->

        <!--<el-form-item label="允收货龄：">-->
          <!--<div class="input"><span v-show="form.allowGoodsAge || form.allowGoodsAge === 0">1/{{form.allowGoodsAge}}</span></div>-->
        <!--</el-form-item>-->
        <!--<el-form-item label="开单分类文本：">-->
          <!--<div class="input">{{form.sapOpeningCategoryText}}</div>-->
        <!--</el-form-item>-->
        <el-form-item label="终端编码："
          prop="terminalCode"
          >
          <el-input v-model="form.terminalCode" placeholder="请输入" class="input">
          </el-input>
        </el-form-item>
        <el-form-item label="备注：" >
          <el-input v-model="form.remark" placeholder="请输入" class="input">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <searchDialog ref="dlg"></searchDialog>
  </div>
</template>

<script>
import formHeader from '../components/form-header'
import searchDialog from '../components/search-dialog'
import { methodPost, methodGet } from '../../api/request'
export default {
  components: {
    formHeader,
    searchDialog
  },
  data() {
    return {
      id: this.$route.query.id,
      showBack: false,
      form: {
        sapCustomerId: '', // 回显值
        id: '',
        system: null,
        sysId: '',
        sysCode: '',
        sysName: '',
        sysStoreCode: '',
        sysStoreName: '',
        status: '',
        splitGround: null,
        warehousePlot: null,
        SAP_OrderCustomer: '',
        sapCustomerCode: '',
        wwDeliveryBranchOfficeCode: '',
        wwOpeningOrderBranchOfficeCode: '',
        productSpart: '',
        wwOpeningOrderChannelCode: '',
        wwDeliveryBranchOfficeName: '',
        wwOpeningOrderBranchOfficeName: '',
        wwOpeningOrderChannelName: '',
        wwStoreCode: '',
        wwStoreName: '',
        frozen: '',
        deleted: '',
        orderType: '',
        allowGoodsAge: '',
        sapOpeningCategoryText: '',
        terminalCode: '',
        remark: ''
      },
      showHide: false,
      systems: [],
      customers: [],
      companies: []
    }
  },
  created() {
    const reqs = [];
    reqs.push(methodPost('/bill/findSysBillList', { "pageNo": 1, "pageSize": 10000 }))
    reqs.push(methodPost('/sysSapDataSaleOrg/findSysSapDataSaleOrgListNoPage', { "pageNo": 1, "pageSize": 10000 }));
    if (this.id) {
      reqs.push(methodGet(`/storebill/findSysBillById/${this.id}`));
    }

    Promise.all(reqs).then(res => {
      if (res[0].code || res[1].code || (this.id && res[2].code)) {
        this.$message.error('网络异常，请稍后再试')
        return;
      }
      this.systems = res[0].data.data;
      this.companies = res[1].data;
      if (this.id) {
        const data = res[2].data
        console.log(data)
        this.form = {
          id: data.sapCustomerCode,
          system: this.systems.find(o => o.id === data.sysId) || {},
          sysId: data.sysId,
          sapCustomerId: data.sapCustomerId,
          sysCode: data.sysCode,
          sysName: data.sysName,
          productSpart: data.productSpart || '',
          sysStoreCode: data.sysStoreCode,
          sysStoreName: data.sysStoreName,
          status: data.status,
          splitGround: this.companies.find(o => o.vkorg === data.codeSplitGround),
          warehousePlot: this.companies.find(o => o.vkorg === data.codeWarehousePlot),
          SAP_OrderCustomer: data.sapCustomerName || '',
          sapCustomerCode: data.sapCustomerCode,
          wwDeliveryBranchOfficeCode: data.wwDeliveryBranchOfficeCode,
          wwDeliveryBranchOfficeName: data.wwDeliveryBranchOfficeName,
          wwOpeningBranchOfficeCode: data.wwOpeningBranchOfficeCode,
          wwOpeningBranchOfficeName: data.wwOpeningBranchOfficeName,
          wwOpeningOrderChannelCode: data.wwOpeningOrderChannelCode,
          wwOpeningOrderChannelName: data.wwOpeningOrderChannelName,
          wwStoreCode: data.wwStoreCode,
          wwStoreName: data.wwStoreName,
          frozen: data.frozen,
          deleted: data.deleted,
          orderType: data.orderType,
          allowGoodsAge: data.allowGoodsAge,
          sapOpeningCategoryText: data.sapOpeningCategoryText,
          terminalCode: data.terminalCode,
          remark: data.remark
        }
      }
    })
  },
  methods: {
    change() {
      this.$refs.form.clearValidate(['status'])
    },
    clear() {
      this.form.sapCustomerCode = ''
      this.form.SAP_OrderCustomer = ''
      this.form.wwOpeningOrderChannelCode = ''
      this.form.productSpart = ''
      this.form.wwOpeningOrderChannelCode = ''
      this.form.wwOpeningOrderChannelName = ''
      this.form.wwDeliveryBranchOfficeCode = ''
      this.form.wwDeliveryBranchOfficeName = ''
      this.form.wwOpeningBranchOfficeCode = ''
      this.form.wwOpeningBranchOfficeName = ''
      this.form.frozen = ''
      this.form.deleted = ''
      this.form.orderType = ''
      this.form.allowGoodsAge = ''
      this.form.sapOpeningCategoryText = ''
    },
    systemChange() {
      this.form.sapCustomerCode = ''
      this.form.SAP_OrderCustomer = ''
      // 送货分公司代号
      this.form.wwDeliveryBranchOfficeCode = ''
      this.form.wwDeliveryBranchOfficeName = ''
      // 开单分公司代号
      this.form.wwOpeningBranchOfficeCode = ''
      this.form.wwOpeningBranchOfficeName = ''
      // 达能开单渠道分销渠道代号
      this.form.wwOpeningOrderChannelCode = ''
      this.form.wwOpeningOrderChannelName = ''
      this.form.productSpart = ''
      this.form.deleted = ''
      this.form.frozen = ''
      this.form.orderType = ''
      this.form.allowGoodsAge = ''
      this.form.sapOpeningCategoryText = ''
    },
    openSAPDialog() {
      if (!this.form.system || !this.form.system.code) {
        this.$message.error('请先选择系统')
        return
      }

      this.$refs.dlg.open({
        dlgTitle: '选择开单客户',
        url: '/account/findSapCustomerBillListDependOnCustomerCode',
        emptyMessage: '请选择客户',
        emptyErrorText: '该系统无匹配的开单客户代号',
        additionalParams: {
          sysCode: this.form.system.code
        },
        tableColumns: [
          { name: 'customerCode', label: '开单客户代号' },
          { name: 'customerName', label: '开单客户名称' },
          { name: 'wwDcompanyCode', label: '送货分公司代号' },
          { name: 'wwDcompanyName', label: '送货分公司名称' },
          { name: 'wwOcompanyCode', label: '开单分公司代号' },
          { name: 'wwOcompanyName', label: '开单分公司名称' },
          { name: 'channel', label: '分销渠道代号' },
          { name: 'productSpart', label: '产品组代号' },
          { name: 'channelName', label: '开单渠道名称' },
          { name: 'aufsd', label: '是否冻结', translater: v => v === '冻结' ? 'Y' : 'N' },
          { name: 'loevm', label: '是否删除', translater: v => v === 'X' ? 'Y' : 'N' },
          { name: 'orderType', label: '订单类型' },
          { name: 'goodAge', label: '允收货龄', formatter: v => '1/' + v }
        ],
        // selectType: 1,
        selectId: !this.showBack ? -1111 : this.form.sapCustomerId,
        placeholder: '请输入开单客户代号或名称',
        idField: 'id'
      }).then(item => {
        console.log(item)
        this.showBack = true
        this.$refs.dlg.close()
        // 开单客户代号
        // this.form.id = item.id
        this.form.sapCustomerId = item.id
        this.form.sapCustomerCode = item.customerCode
        this.form.SAP_OrderCustomer = item.customerName
        this.form.productSpart = item.productSpart || ''
        // 送货分公司代号
        this.form.wwDeliveryBranchOfficeCode = item.wwDcompanyCode
        this.form.wwDeliveryBranchOfficeName = item.wwDcompanyName
        // 开单分公司代号
        this.form.wwOpeningBranchOfficeCode = item.wwOcompanyCode
        this.form.wwOpeningBranchOfficeName = item.wwOcompanyName
        // 达能开单渠道分销渠道代号
        this.form.wwOpeningOrderChannelCode = item.channel
        this.form.wwOpeningOrderChannelName = item.channelName
        this.form.deleted = item.loevm
        this.form.frozen = item.aufsd
        this.form.orderType = item.orderType
        this.form.allowGoodsAge = item.goodAge
        this.form.sapOpeningCategoryText = item.sysSapText
        // console.log(item)
        // console.log('------------')
      })
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.sysId = this.form.system.id;
          this.form.sysCode = this.form.system.code;
          this.form.sysName = this.form.system.name;
          methodPost(`/storebill/${this.id ? 'modifySysOkuraBill' : 'saveSysStoreBill'}`, {
            ...this.form,
            codeSplitGround: this.form.splitGround.vkorg,
            nameSplitGround: this.form.splitGround.vremark, // 4.19
            codeWarehousePlot: this.form.warehousePlot.vkorg,
            nameWarehousePlot: this.form.warehousePlot.vremark, // 4.19
            id: this.id
          }).then(res => {
            // console.log(res);

            if (res.code !== 0) {
              this.$message.error(res.message || '保存出错，请稍后再试')
            } else {
              this.$message.success(`${this.id ? '修改' : '新增'}成功`)
              this._gobackRefresh(this, this.$route.fullPath, null, 'system_store_bill_list')
            }
          })
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style lang="scss" >

.sysStoreEdit{
  // display: flex;
  // flex: 1;
  //padding: 0 0 0 20px;
  .el-form-item__error{
    left: 315px !important;
  }
  .content-area{
    // flex: 1;
    margin-top: 20px;
    padding-top: 20px;
    background: #fff;

    .input{
      width: 300px;
      white-space: nowrap;
      font-size:12px;
    }
    .el-select {
      width: 300px;
    }
  }
}
</style>

<style lang="scss">
.clickable{
  cursor: pointer !important;
  .el-input__inner{
    cursor: pointer !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/systemStore/edit.vue